<template>
	<div class="box-page">
		<i-modal ref="modalDetailPengiriman">
			<template v-slot:title>
				<div class="modal-title pl-3 font-size-12 font-size-sm-10 font-weight-bold">Detail Pengiriman</div>
			</template>
			<template v-slot:body>
				<DetailReceipt></DetailReceipt>
			</template>
			<template v-slot:footer>
				<div class="footer-modal">
				</div>
			</template>
		</i-modal>
		<i-modal ref="modalDetailPemesanan" class="modal-small">
			<template v-slot:title>
				<div class="modal-title pl-3 font-size-12 font-size-sm-10 font-weight-bold">Detail Pemesanan</div>
			</template>
			<template v-slot:body>
				<div class="col-12 font-size-11 pb-4 pl-0 pr-0 pl-md-3 pr-md-3" v-if="Object.values(detailSO).length > 0">
					<div class="col-12 pl-0 pr-0">
						<div class="col-12 col-md-12 pl-0">
							<div class="col-12 pl-0 pr-0 text-center code-detail-product font-size-12 font-size-sm-10 font-weight-bold mb-3">
								Detail Data
							</div>
							<div class="row pl-0">
								<div class="col-6 col-md-6">
									<div class="font-weight-bold">Kode</div>
									<div>{{ detailSO.so_code }}</div>
								</div>
								<div class="col-6 col-md-6">
									<div class="font-weight-bold">Status</div>
									<div>{{ detailSO.so_status_text }}</div>
								</div>
								<div class="col-6 col-md-6">
									<div class="font-weight-bold">Catatan</div>
									<div>{{ detailSO.so_note ? detailSO.so_note : '-' }}</div>
								</div>
								<div class="col-6 col-md-6">
									<div class="font-weight-bold">Catatan Pembayaran</div>
									<div><span v-html="detailSO.so_payment_note"></span></div>
								</div>
								<div class="col-6 col-md-6" v-if="detailSO.so_order_from == 'pos'">
									<div class="font-weight-bold">Metode Pembayaran</div>
									<div>{{ detailSO.so_payment_type_label }}</div>
								</div>
								<div class="col-6 col-md-6" v-if="detailSO.so_order_from == 'pos'">
									{{ paymentType() }}
									<div class="font-weight-bold">Detail Pembayaran</div>
									<div>
										<div v-if="so_payment_type.includes('bank_transfer') && detailSO.so_payment_type != ''">
											{{ detailSO.so_payment_data.bank_account_bank }} {{ detailSO.so_payment_data.bank_account_no }} a/n {{ detailSO.so_payment_data.bank_account_name }}
										</div>
										<div v-else-if="so_payment_type.includes('va_bca') && detailSO.so_payment_type != '' && detailSO.so_status != 'canceled'">
											VA {{ detailSO.so_payment_data.va_bank }} {{ detailSO.so_payment_data.va_number }} - Batas Pembayaran {{ detailSO.so_payment_data.va_expired }}
										</div>
										<div v-else></div>
										<div v-if="so_payment_type.includes('bank_transfer') && detailSO.so_payment_type != ''">
											<div v-if="detailSO.so_customer_bank != null">
												{{ detailSO.so_customer_bank.customer_bank_name }} {{ detailSO.so_customer_bank.customer_bank_customer_number }} a/n {{ detailSO.so_customer_bank.customer_bank_customer_name }}
											</div>
										</div>
									</div>
								</div>
								<div class="col-6 col-md-6" v-if="detailSO.so_order_from == 'pos' && (detailSO.so_status == 'approval_refund' || detailSO.so_status == 'canceled')">
									<div v-if="detailSO.refund_data">
										<div class="font-weight-bold">Detail Pengembalian Dana</div>
										<div>{{ detailSO.refund_data.refund_data_bank_name }}</div>
										<div>{{ detailSO.refund_data.refund_data_bank_customer_name }}</div>
										<div>{{ detailSO.refund_data.refund_data_bank_customer_number }}</div>
									</div>
								</div>
							</div>
						</div>
						<div class="col-12 col-md-12 pl-0 pr-0 font-size-10 mt-4">
							<div class="col-12 pl-0 pr-0 text-center code-detail-product font-size-12 font-size-sm-10 font-weight-bold mb-3">
								Detail Produk
							</div>
							<div class="col-12 pl-0 pr-0 d-flex flex-wrap" v-for="(product, index) in detailSO.so_detail" :key="index">
								<div class="col-12 col-md-5 pl-0 pb-1 pb-md-3">{{product.so_detail_product_name}}</div>
								<div class="col-5 col-md-2 pl-md-0 pr-0 text-md-right color-gray-2">@{{product.so_detail_product_price | toNumber}}</div>
								<div class="col-3 col-md-2 pl-0 text-right color-gray-2">{{product.so_detail_quantity_sold}}</div>
								<div class="col-4 col-md-3 pl-0 text-right color-gray-2">{{(product.so_detail_quantity_sold * product.so_detail_product_price) | toNumber}}</div>
							</div>
							<div class="col-12 pl-0 pr-0 d-flex pt-2 pt-md-0">
								<div class="col-6 pl-0 font-weight-bold">Total Belanja</div>
								<div class="col-6 pl-0 font-weight-bold text-right">{{sumTotal(detailSO.so_detail) | toRupiah}}</div>
							</div>
							<div class="col-12 pl-0 pr-0 d-flex pt-2 pt-md-0" v-if="(sumTotal(detailSO.so_detail) * detailSO.so_discount_percent / 100) > 0">
								<div class="col-6 pl-0 font-weight-bold">Diskon</div>
								<div class="col-6 pl-0 font-weight-bold text-right">{{sumTotal(detailSO.so_detail) * detailSO.so_discount_percent / 100 | toRupiah}}</div>
							</div>
							<div class="col-12 pl-0 pr-0 d-flex pt-2 pt-md-0" v-if="detailSO.so_rebate_value > 0">
								<div class="col-6 pl-0 font-weight-bold">Potongan Harga</div>
								<div class="col-6 pl-0 font-weight-bold text-right">{{detailSO.so_rebate_value | toRupiah}}</div>
							</div>
							<div class="col-12 pl-0 pr-0 d-flex pt-2 pt-md-0" v-if="parseInt(detailSO.so_materai_value) > 0">
								<div class="col-6 pl-0 font-weight-bold">Materai</div>
								<div class="col-6 pl-0 font-weight-bold text-right">{{ parseInt(detailSO.so_materai_value) | toRupiah}}</div>
							</div>
							<div class="col-12 pl-0 pr-0 d-flex pt-2 pt-md-0">
								<div class="col-6 pl-0 font-weight-bold">Total Bayar</div>
								<div class="col-6 pl-0 font-weight-bold text-right">{{sumTotal(detailSO.so_detail) * (100 - detailSO.so_discount_percent) / 100 - parseInt(detailSO.so_rebate_value) + parseInt(detailSO.so_materai_value) | toRupiah}}</div>
							</div>
						</div>
						<div class="col-12 col-md-12 pl-0 pr-0 font-size-10 mt-4">
							<div class="col-12 pl-0 pr-0 text-center code-detail-product font-size-12 font-size-sm-10 font-weight-bold mb-3">
								Riwayat Status
							</div>
							<div class="col-12 pl-0 pr-0 d-flex flex-wrap" v-if="detailSO.so_status_canceled_datetime">
								<div class="col-4 col-md-4 pl-0 pb-1 pb-md-3" :class="detailSO.so_status == 'canceled' ? 'color-orange font-weight-bold' : ''">Dibatalkan</div>
								<div class="col-4 col-md-4 pl-md-0 pr-0 color-gray-2">{{detailSO.so_status_canceled_user_name}}</div>
								<div class="col-4 col-md-4 pl-0 text-right color-gray-2">{{ detailSO.so_status_canceled_datetime | toTanggal}}</div>
							</div>

							<div class="col-12 pl-0 pr-0 d-flex flex-wrap" v-if="detailSO.so_status_approval_refund_datetime_approved">
								<div class="col-4 col-md-4 pl-0 pb-1 pb-md-3">Dana Dikembalikan</div>
								<div class="col-4 col-md-4 pl-md-0 pr-0 color-gray-2">{{detailSO.so_status_approval_refund_user_name_approved}}</div>
								<div class="col-4 col-md-4 pl-0 text-right color-gray-2">{{ detailSO.so_status_approval_refund_datetime_approved | toTanggal}}</div>
							</div>

							<div class="col-12 pl-0 pr-0 d-flex flex-wrap" v-if="detailSO.so_status_approval_refund_datetime">
								<div class="col-4 col-md-4 pl-0 pb-1 pb-md-3" :class="detailSO.so_status == 'approval_refund' ? 'color-orange font-weight-bold' : ''">Proses Pengembalian Dana</div>
								<div class="col-4 col-md-4 pl-md-0 pr-0 color-gray-2">{{detailSO.so_status_approval_refund_user_name}}</div>
								<div class="col-4 col-md-4 pl-0 text-right color-gray-2">{{ detailSO.so_status_approval_refund_datetime | toTanggal}}</div>
							</div>

							<div class="col-12 pl-0 pr-0 d-flex flex-wrap" v-if="detailSO.so_status_completed_datetime">
								<div class="col-4 col-md-4 pl-0 pb-1 pb-md-3" :class="detailSO.so_status == 'completed' ? 'color-blue font-weight-bold' : ''">Selesai</div>
								<div class="col-4 col-md-4 pl-md-0 pr-0 color-gray-2">{{detailSO.so_status_completed_user_name}}</div>
								<div class="col-4 col-md-4 pl-0 text-right color-gray-2">{{ detailSO.so_status_completed_datetime | toTanggal}}</div>
							</div>
							<div class="col-12 pl-0 pr-0 d-flex flex-wrap" v-if="detailSO.so_status_processed_datetime">
								<div class="col-4 col-md-4 pl-0 pb-1 pb-md-3" :class="detailSO.so_status == 'processed' ? 'color-blue font-weight-bold' : ''">Sedang Dikirim</div>
								<div class="col-4 col-md-4 pl-md-0 pr-0 color-gray-2">{{detailSO.so_status_processed_user_name}}</div>
								<div class="col-4 col-md-4 pl-0 text-right color-gray-2">{{ detailSO.so_status_processed_datetime | toTanggal}}</div>
							</div>
							<div class="col-12 pl-0 pr-0 d-flex flex-wrap" v-if="detailSO.so_status_approved_datetime">
								<div class="col-4 col-md-4 pl-0 pb-1 pb-md-3" :class="detailSO.so_status == 'approved' ? 'color-blue font-weight-bold' : ''">Menunggu Dikirim</div>
								<div class="col-4 col-md-4 pl-md-0 pr-0 color-gray-2">{{detailSO.so_status_approved_user_name}}</div>
								<div class="col-4 col-md-4 pl-0 text-right color-gray-2">{{ detailSO.so_status_approved_datetime | toTanggal}}</div>
							</div>
							<div class="col-12 pl-0 pr-0 d-flex flex-wrap" v-if="detailSO.so_status_paid_datetime">
								<div class="col-4 col-md-4 pl-0 pb-1 pb-md-3" :class="detailSO.so_status == 'paid' ? 'color-blue font-weight-bold' : ''">Pembayaran Diterima</div>
								<div class="col-4 col-md-4 pl-md-0 pr-0 color-gray-2">{{detailSO.so_status_paid_user_name}}</div>
								<div class="col-4 col-md-4 pl-0 text-right color-gray-2">{{ detailSO.so_status_paid_datetime | toTanggal}}</div>
							</div>
							<div class="col-12 pl-0 pr-0 d-flex flex-wrap" v-if="detailSO.so_status_created_datetime">
								<div class="col-4 col-md-4 pl-0 pb-1 pb-md-3" :class="detailSO.so_status == 'created' ? 'color-blue font-weight-bold' : ''">Dibuat</div>
								<div class="col-4 col-md-4 pl-md-0 pr-0 color-gray-2">{{detailSO.so_status_created_user_name}}</div>
								<div class="col-4 col-md-4 pl-0 text-right color-gray-2">{{detailSO.so_status_created_datetime | toTanggal}}</div>
							</div>
						</div>
					</div>
				</div>
			</template>
			<template v-slot:footer>
				<div class="footer-modal">
				</div>
			</template>
		</i-modal>
		<i-modal ref="modalAlert" class="modal-small">
			<template v-slot:header>
				<div></div>
			</template>
			<template v-slot:body>
				<AlertModal :message="alert" type="alert" @remove="$refs.modalAlert.modalHide()"/>
			</template>
			<template v-slot:footer>
				<div class="footer-modal">
					<div></div>
				</div>
			</template>
		</i-modal>
		<i-modal ref="modalConfirmation" class="modal-small">
			<template v-slot:header>
				<div></div>
			</template>
			<template v-slot:body>
				<AlertModal title="Konfirmasi" :message="confirmMessage" type="confirmation" @remove="$refs.modalConfirmation.modalHide()" @confirm="confirmDelivery"/>
			</template>
			<template v-slot:footer>
				<div class="footer-modal">
					<div></div>
				</div>
			</template>
		</i-modal>
		<i-modal ref="modalConfirmationCancel" class="modal-small">
			<template v-slot:header>
				<div></div>
			</template>
			<template v-slot:body>
				<AlertModal title="Konfirmasi Pembatalan" :message="confirmMessage" type="confirmation" @remove="$refs.modalConfirmationCancel.modalHide()" @confirm="confirmCancel"/>
			</template>
			<template v-slot:footer>
				<div class="footer-modal">
					<div></div>
				</div>
			</template>
		</i-modal>
		<i-modal ref="modalPengajuanPembatalan" class="modal-small">
			<template v-slot:title>
				<div class="modal-title pl-3 font-size-12 font-size-sm-10 font-weight-bold">Pengajuan Pembatalan</div>
			</template>
			<template v-slot:body>
				<div class="col-12 font-size-11 pb-2 pl-0 pr-0">
					<div class="col-12 pl-0 pr-0">
						<div class="col-12 col-md-12 pl-0 mb-3">
							Data dibawah ini akan digunakan sebagai acuan Pengembalian Dana Anda, mohon dilengkapi dengan benar.
						</div>
						<div class="col-12 col-md-12 p-2 mb-3 bg-danger color-white rounded-cus" v-if="refund_error_message != ''">
							{{ refund_error_message }}
						</div>
						<div class="col-12 col-md-12 pl-0 mb-3">
							<div class="font-size-9 pb-1">Nama Bank <span class="color-red">*</span></div>
							<!-- <input class="form-control box-blue rounded-cus font-size-11" type="text" placeholder="eg. Bank XXX" v-model="refund_data_bank_name"> -->
							<v-select v-model="refund_data_bank_name" :options="dataBank" class="font-size-10" label="bank_name" :reduce="el => el.bank_name" placeholder="Nama Bank">
								<template v-slot:no-options>
									Tidak ada data bank
								</template>
							</v-select>
						</div>
						<div class="col-12 col-md-12 pl-0 mb-3">
							<div class="font-size-9 pb-1">Nama Pemilik Rekening <span class="color-red">*</span></div>
							<input class="form-control box-blue rounded-cus font-size-11" type="text" placeholder="e.g John Doe" v-model="refund_data_bank_customer_name">
						</div>
						<div class="col-12 col-md-12 pl-0 mb-3">
							<div class="font-size-9 pb-1">Nomor Rekening <span class="color-red">*</span></div>
							<input class="form-control box-blue rounded-cus font-size-11" type="text" placeholder="e.g 115475" v-model="refund_data_bank_customer_number" @keypress="onlyNumber" @paste.prevent>
						</div>
					</div>
				</div>
			</template>
			<template v-slot:footer>
				<div class="col-12 text-right pb-3 pt-3 border-top">
					<div class="col-12">
						<button class="btn btn-outline-danger mr-2" @click="tutupModalRefund()">Tutup</button><button class="btn btn-blue mr-2" @click="confirmCancelRefund()">Ajukan Pembatalan</button>
					</div>
				</div>
			</template>
		</i-modal>
		<div class="col-12 pl-0 pr-0">
			<div class="col-12 pl-0 pr-0">
				<div class="col-12 p-3 d-flex flex-wrap rounded-cus cus-box-shadow bg-blue color-white">
					<div class="col-12 col-md-8 col-lg-9 pl-0 mt-auto mb-auto">
						<div class="col-12 pl-1 font-size-12 font-size-sm-10">Pemesanan Barang</div>
						<div class="col-12 pl-1 font-size-16 font-size-sm-14 font-weight-bold">List Pemesanan Barang</div>
					</div>
					<div class="col-7 col-md-4 col-lg-3 pl-0 pr-0 pt-2 pt-md-0 mt-auto mb-auto d-flex justify-content-end">
					</div>
				</div>
			</div>

			<!-- <div class="col-12 pl-0 pt-3 pr-0 d-flex order-2 d-md-none">
				<div class="col-12 pl-0 pr-0 pt-3 pt-lg-0">
					<div class="col-12 py-1 py-md-3 bg-white rounded-cus cus-box-shadow h-100">
						<ul class="nav nav-pills font-size-10 d-flex justify-content-start flex-nowrap">
							<div :class="next == 1 ? 'd-none' : 'd-flex'" class="relative">
								<li class="purchase-order-dashboard nav-item" @click="getDataFilter('created')" :class="status.value == 'created' ? 'active' : ''">
									<div
										class="p-3 box-serial d-flex flex-column align-items-center">
										<i class="fas fa-lg fa-box-open"></i>
										<span class="mt-2">
											Dibuat
										</span>
										<span class="badge-dashboard" v-if="dataPurchaseOrder.dibuat > 0">{{ dataPurchaseOrder.dibuat }}</span>
									</div>
								</li>
								<li class="purchase-order-dashboard nav-item ml-3" @click="getDataFilter('paid')" :class="status.value == 'paid' ? 'active' : ''">
									<div
										class="p-3 box-serial d-flex flex-column align-items-center">
										<i class="fas fa-lg fa-wallet"></i>
										<span class="mt-2">
											Dibayar
										</span>
										<span class="badge-dashboard" v-if="dataPurchaseOrder.dibayar > 0">{{ dataPurchaseOrder.dibayar }}</span>
									</div>
								</li>
								<li class="purchase-order-dashboard nav-item" @click="getDataFilter('approved')" :class="status.value == 'approved' ? 'active' : ''">
									<div
										class="p-3 box-serial d-flex flex-column align-items-center">
										<i class="fas fa-lg fa-truck-loading"></i>
										<span class="mt-2">
											Diproses
										</span>
										<span class="badge-dashboard" v-if="dataPurchaseOrder.diproses > 0">{{ dataPurchaseOrder.diproses }}</span>
									</div>
								</li>
								<div v-if="next == 0" @click="nextDis()"
									class="p-3 box-serial position-absolute" style="right: -5px;top: 15px;">
									<i class="fas fa-chevron-right"></i>
								</div>
							</div>
							<div :class="next == 0 ? 'd-none' : 'd-flex'">
								<div v-if="next == 1" @click="prevDis()"
									class="p-3 box-serial position-absolute" style="left: 0px;top: 15px;">
									<i class="fas fa-chevron-left"></i>
								</div>
								<li class="purchase-order-dashboard nav-item" @click="getDataFilter('approved')" :class="status.value == 'approved' ? 'active' : ''">
									<div
										class="p-3 box-serial d-flex flex-column align-items-center">
										<i class="fas fa-lg fa-truck-loading"></i>
										<span class="mt-2">
											Diproses
										</span>
										<span class="badge-dashboard" v-if="dataPurchaseOrder.diproses > 0">{{ dataPurchaseOrder.diproses }}</span>
									</div>
								</li>
								<li class="purchase-order-dashboard nav-item " @click="getDataFilter('processed')" :class="status.value == 'processed' ? 'active' : ''">
									<div
										class="p-3 box-serial d-flex flex-column align-items-center">
										<i class="fas fa-lg fa-truck-moving"></i>
										<span class="mt-2">
											Dikirm
										</span>
										<span class="badge-dashboard" v-if="dataPurchaseOrder.dikirim > 0">{{ dataPurchaseOrder.dikirim }}</span>
									</div>
								</li>
								<li class="purchase-order-dashboard nav-item" @click="getDataFilter('completed')" :class="status.value == 'completed' ? 'active' : ''">
									<div
										class="p-3 box-serial d-flex flex-column align-items-center" style="white-space: nowrap;">
										<i class="fas fa-lg fa-clipboard-list"></i>
										<span class="mt-2" style="white-space: wrap;">
											Selesai
										</span>
										<span class="badge-dashboard" v-if="dataPurchaseOrder.selesai > 0">{{ dataPurchaseOrder.selesai }}</span>
									</div>
								</li>
							</div>
						</ul>
					</div>
				</div>
			</div> -->

			<div class="col-12 d-flex w-full px-0 pt-3 d-md-none">
				<div class="col-12 bg-white rounded-cus cus-box-shadow h-100 overflow-auto">
					<ul class="nav nav-pills font-size-10 d-flex justify-content-around flex-nowrap p-2">
						<li class="purchase-order-dashboard nav-item" @click="getDataFilter('created')" :class="status.value == 'created' ? 'active' : ''">
							<div
								class="p-3 box-serial d-flex flex-column align-items-center">
								<i class="fas fa-lg fa-box-open"></i>
								<span class="mt-2">
									Dibuat
								</span>
								<span class="badge-dashboard" v-if="dataPurchaseOrder.dibuat > 0">{{ dataPurchaseOrder.dibuat }}</span>
							</div>
						</li>
						<li class="purchase-order-dashboard nav-item" @click="getDataFilter('paid')" :class="status.value == 'paid' ? 'active' : ''">
							<div
								class="p-3 box-serial d-flex flex-column align-items-center">
								<i class="fas fa-lg fa-wallet"></i>
								<span class="mt-2">
									Dibayar
								</span>
								<span class="badge-dashboard" v-if="dataPurchaseOrder.dibayar > 0">{{ dataPurchaseOrder.dibayar }}</span>
							</div>
						</li>
						<li class="purchase-order-dashboard nav-item" @click="getDataFilter('approved')" :class="status.value == 'approved' ? 'active' : ''">
							<div
								class="p-3 box-serial d-flex flex-column align-items-center">
								<i class="fas fa-lg fa-truck-loading"></i>
								<span class="mt-2">
									Diproses
								</span>
								<span class="badge-dashboard" v-if="dataPurchaseOrder.diproses > 0">{{ dataPurchaseOrder.diproses }}</span>
							</div>
						</li>
						<li class="purchase-order-dashboard nav-item" @click="getDataFilter('processed')" :class="status.value == 'processed' ? 'active' : ''">
							<div
								class="p-3 box-serial d-flex flex-column align-items-center">
								<i class="fas fa-lg fa-truck-moving"></i>
								<span class="mt-2">
									Dikirm
								</span>
								<span class="badge-dashboard" v-if="dataPurchaseOrder.dikirim > 0">{{ dataPurchaseOrder.dikirim }}</span>
							</div>
						</li>
						<li class="purchase-order-dashboard nav-item" @click="getDataFilter('completed')" :class="status.value == 'completed' ? 'active' : ''">
							<div
								class="p-3 box-serial d-flex flex-column align-items-center">
								<i class="fas fa-lg fa-clipboard-list"></i>
								<span class="mt-2 text-center">
									Pesanan Selesai
								</span>
								<span class="badge-dashboard" v-if="dataPurchaseOrder.selesai > 0">{{ dataPurchaseOrder.selesai }}</span>
							</div>
						</li>
						<li class="purchase-order-dashboard nav-item" @click="getDataFilter('approval_refund')" :class="status.value == 'approval_refund' ? 'active' : ''">
							<div
								class="p-3 box-serial d-flex flex-column align-items-center">
								<i class="fas fa-lg fa-money-bill"></i>
								<span class="mt-2 text-center">
									Pengembalian Dana
								</span>
								<span class="badge-dashboard" v-if="dataPurchaseOrder.refund > 0">{{ dataPurchaseOrder.refund }}</span>
							</div>
						</li>
					</ul>
				</div>
			</div>

			<div class="col-12 pl-0 pt-3 pr-0 order-2 d-none d-md-flex">
				<div class="col-12 pl-0 pr-0 pt-3 pt-lg-0">
					<div class="col-12 py-1 py-md-3 bg-white rounded-cus cus-box-shadow h-100 overflow-auto" style="scrollbar-width: none;">
						<ul class="nav nav-pills font-size-10 d-flex justify-content-around flex-nowrap">
							<li class="purchase-order-dashboard nav-item" @click="getDataFilter('created')" :class="status.value == 'created' ? 'active' : ''">
								<div
									class="p-3 box-serial d-flex flex-column align-items-center">
									<i class="fas fa-lg fa-box-open"></i>
									<span class="mt-2">
										Dibuat
									</span>
									<span class="badge-dashboard" v-if="dataPurchaseOrder.dibuat > 0">{{ dataPurchaseOrder.dibuat }}</span>
								</div>
							</li>
							<li class="purchase-order-dashboard nav-item" @click="getDataFilter('paid')" :class="status.value == 'paid' ? 'active' : ''">
								<div
									class="p-3 box-serial d-flex flex-column align-items-center">
									<i class="fas fa-lg fa-wallet"></i>
									<span class="mt-2">
										Dibayar
									</span>
									<span class="badge-dashboard" v-if="dataPurchaseOrder.dibayar > 0">{{ dataPurchaseOrder.dibayar }}</span>
								</div>
							</li>
							<li class="purchase-order-dashboard nav-item" @click="getDataFilter('approved')" :class="status.value == 'approved' ? 'active' : ''">
								<div
									class="p-3 box-serial d-flex flex-column align-items-center">
									<i class="fas fa-lg fa-truck-loading"></i>
									<span class="mt-2">
										Diproses
									</span>
									<span class="badge-dashboard" v-if="dataPurchaseOrder.diproses > 0">{{ dataPurchaseOrder.diproses }}</span>
								</div>
							</li>
							<li class="purchase-order-dashboard nav-item" @click="getDataFilter('processed')" :class="status.value == 'processed' ? 'active' : ''">
								<div
									class="p-3 box-serial d-flex flex-column align-items-center">
									<i class="fas fa-lg fa-truck-moving"></i>
									<span class="mt-2">
										Dikirm
									</span>
									<span class="badge-dashboard" v-if="dataPurchaseOrder.dikirim > 0">{{ dataPurchaseOrder.dikirim }}</span>
								</div>
							</li>
							<li class="purchase-order-dashboard nav-item" @click="getDataFilter('completed')" :class="status.value == 'completed' ? 'active' : ''">
								<div
									class="p-3 box-serial d-flex flex-column align-items-center" style="white-space: nowrap;">
									<i class="fas fa-lg fa-clipboard-list"></i>
									<span class="mt-2">
										Selesai
									</span>
									<span class="badge-dashboard" v-if="dataPurchaseOrder.selesai > 0">{{ dataPurchaseOrder.selesai }}</span>
								</div>
							</li>
							<li class="purchase-order-dashboard nav-item" @click="getDataFilter('approval_refund')" :class="status.value == 'approval_refund' ? 'active' : ''">
								<div
									class="p-3 box-serial d-flex flex-column align-items-center" style="white-space: nowrap;">
									<i class="fas fa-lg fa-money-bill"></i>
									<span class="mt-2">
										Pengembalian Dana
									</span>
									<span class="badge-dashboard" v-if="dataPurchaseOrder.refund > 0">{{ dataPurchaseOrder.refund }}</span>
								</div>
							</li>
						</ul>
					</div>
				</div>
			</div>

			<div class="col-12 pl-0 pr-0">
				<div class="row" v-if="listReceipt.length == 0">
					<div class="col-12 pr-0 d-flex">
						<div class="col-4 pl-0 pt-3" v-for="(index) in 3" :key="index">
							<div class="col-12 pt-3 pb-3 rounded-cus cus-box-shadow bg-white">
								<vcl :width='300' :height='135'>
									<rect x="5" y="4" rx="2" ry="2" width="40" height="30" />
									<rect x="5" y="51" rx="2" ry="2" width="75" height="12" />
									<rect x="5" y="71" rx="2" ry="2" width="120" height="12" />
									<rect x="5" y="101" rx="2" ry="2" width="75" height="12" />
									<rect x="5" y="121" rx="2" ry="2" width="120" height="12" />
									<rect x="255" y="104" rx="2" ry="2" width="40" height="30" />
								</vcl>
							</div>
						</div>
					</div>
				</div>
				<div class="row" v-else-if="listReceipt == 'error'">
					<div class="col-12 pr-0 d-flex flex-wrap">
						<div class="col-12 pl-0 pt-3">
							<div class="col-12 pt-3 pb-3 bg-white rounded-cus cus-box-shadow">
								<div class="col-12 text-center">
									<div class="col-6 col-md-3 ml-auto mr-auto">
										<img class="img-fluid" src="/assets/report/ilustrasi-data-kosong-report.png">
									</div>
									<div class="font-size-11 pt-1">Data tidak tersedia!</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="row" v-else>
					<div class="col-12 pr-0 d-flex flex-wrap">
						<div class="col-12 col-md-6 col-lg-4 pl-0 pt-3" v-for="receipt in listReceipt" :key="receipt.sdo_id">
							<div class="col-12 pt-3 pb-3 d-flex flex-wrap rounded-cus cus-box-shadow bg-white">
								<div class="col-3 pt-2 pl-2 pr-2">
									<div class="col-12 pl-0 pr-0 pos" v-if="receipt.so_order_from == 'pos'">
										<!-- <i class="fas fa-shopping-bag color-blue font-size-20"></i> -->
										<svg class="svg-inline--fa fa-shopping-bag fa-w-14 color-blue font-size-20" aria-hidden="true" focusable="false" data-prefix="fas" data-icon="shopping-bag" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" data-fa-i2svg=""><path fill="currentColor" d="M352 160v-32C352 57.42 294.579 0 224 0 153.42 0 96 57.42 96 128v32H0v272c0 44.183 35.817 80 80 80h288c44.183 0 80-35.817 80-80V160h-96zm-192-32c0-35.29 28.71-64 64-64s64 28.71 64 64v32H160v-32zm160 120c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24zm-192 0c-13.255 0-24-10.745-24-24s10.745-24 24-24 24 10.745 24 24-10.745 24-24 24z"></path></svg>
									</div>
									<div class="col-12 pl-0 pr-0 warehouse" v-else>
										<img class="img-fluid" src="/assets/receipt/penerimaan-icon.png">
									</div>
									<span class="color-blue font-size-9">{{ receipt.so_order_from == 'pos' ? 'POS' : 'Warehouse' }}</span>
								</div>
								<div class="col-9 pt-2 pl-2 pr-2 text-right">
									<div class="col-12 pl-0 pr-0">
										{{ receipt.so_status_created_datetime | toTanggal }}
									</div>
								</div>
								<div class="col-12 pt-3 pl-2 pr-2">
									<div class="font-size-11 color-gray-2">Kode Pemesanan</div>
									<div class="pt-1 font-size-12 font-weight-bold color-blue cursor-pointer" @click="getDetail(receipt.so_code)" data-toggle="tooltip" title="Detail Pemesanan">
										<span class="mr-2"><img src="/assets/report/icon-details.svg"></span>
										{{ receipt.so_code }}
									</div>
								</div>
								<div class="col-12 pt-3 pl-2 pr-2" v-if="receipt.sdo_list.length > 0">
									<div class="font-size-11 color-gray-2">Kode Pengiriman</div>
									<div class="pt-1 font-size-12 font-weight-bold color-blue" v-for="(sdo, index) in receipt.sdo_list" :key="index">
										<span class="mr-2 cursor-pointer" @click="showDetailSDO(sdo.sdo_code)" data-toggle="tooltip" title="Detail Pengiriman">
											<img src="/assets/report/icon-details.svg">
										</span>
										{{ sdo.sdo_code }}
										<!-- <button class="btn btn-sm btn-orange box-orange rounded-cus" v-show="sdo.sdo_status != 'completed'">
											<div class="font-size-11 text-uppercase">Proses</div>
										</button> -->
									</div>
								</div>
								<div class="col-12 pt-3 pl-2 pr-2" v-else>
									<div class="font-size-11 color-gray-2">Kode Pengiriman</div>
									<div class="pt-1 font-size-12 font-weight-bold color-blue">
										-
									</div>
								</div>
								<div class="col-12 pt-3 pl-2 pr-2">
									<div class="font-size-11 color-gray-2">Status</div>
									<div class="pt-1 font-size-12 font-weight-bold cursor-pointer d-flex justify-content-between" :class="receipt.sdo_status == 'completed' ? 'color-green' : 'color-orange'">
										<div>{{ receipt.sdo_status_text ? receipt.sdo_status_text : receipt.so_status_text }}</div>
										<div class="d-flex mt-n3">
											<div v-for="(sdo, index) in receipt.sdo_list" :key="index" class="pl-2 color-green cursor-pointer text-right" data-toggle="tooltip" :title="'Proses ' + sdo.sdo_code" @click="receiptDelivery(sdo.sdo_id)" v-show="sdo.sdo_status !== 'completed' && sdo.sdo_status_delivered_user_id">
												<i class="fas fa-check-circle font-size-25"></i>
											</div>
										</div>
										<div class="d-flex mt-n3" v-if="receipt.so_status == 'created'">
											<button class="btn btn-cancel-so" @click="cancel_SO(receipt.so_id)"><i class="fa fa-times-circle"></i> Batalkan</button>
										</div>
										<div class="d-flex mt-n3" v-if="receipt.so_status == 'paid'">
											<button class="btn btn-cancel-so" @click="cancel_SO_refund(receipt.so_id)"><i class="fa fa-times-circle"></i> Ajukan Pembatalan</button>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="col-12 pt-3 pl-2 pr-2 text-center">
							<i-pagination :limit = 'limit' @changeLimit="changeLimit($event)" :pagination = 'pagination' @gotoPage="gotoPage($event)" @refresh="refresh($event)"></i-pagination>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import IModal from '@/components/IModal.vue';
import IPagination from '@/components/IPagination.vue';
import AlertModal from '@/components/elements/alert/AlertModal.vue';
import DetailReceipt from '@/views/receipt/component/DetailReceipt.vue';

export default {
	components: {
		IPagination, IModal, AlertModal, DetailReceipt
	},
	data() {
		return {
			params: {
				sdo_code : '',
			},
			next:1,
			limit : 10,
			page: 1,
			camera: 'front',
			noRearCamera: false,
			noFrontCamera: false,
			alert: '',
			confirmMessage: '',
			sdo_id: '',
			so_payment_type: [],
			cancel_so_id: 0,
			refund_data_bank_name: '',
			refund_data_bank_customer_name: '',
			refund_data_bank_customer_number: '',
			refund_error_message: '',
			status:{
				value:'processed',
				comparison:'=',
				type:'string',
				field:'so_status',
			},
		}
	},
	methods: {
		...mapActions('receipt', ['getReceipt', 'getDetailSO', 'addReceipt', 'getDetailReceipt', 'proccessSerial', 'cancelSO', 'getPurchaseOrder']),
		...mapActions('po', ['getBank']),

		showDetailSDO(code) {
			// let routeData = this.$router.resolve({ name: 'receipt-detail', 'params' : {slug:code} });
			// window.open(routeData.href, '_blank');
			// this.$router.push({ name: 'receipt-detail', 'params' : {slug:code} });
			this.getDetailReceipt({
				sdo_code: code
			}).catch( err =>{
				this.alert = err
				this.$refs.modalAlert.modalShow()
			}).then(() => {
				this.$refs.modalDetailPengiriman.modalShow()
			})
		},
		receiptDelivery(sdo_id) {
			this.sdo_id = sdo_id
			this.confirmMessage = 'Apakah anda yakin sudah menerima pengiriman ini?'
			this.$refs.modalConfirmation.modalShow()
		},
		confirmDelivery() {
			let params = {
				sdo_id: this.sdo_id
			}
			this.proccessSerial(params).then(() => {
				this.$refs.modalConfirmation.modalHide()
				this.getReceipt(this.queryString({page: this.page, limit : this.limit, params:[this.status]}))
				this.getPurchaseOrder()
			}).catch((msg) => {
				this.alert = msg
				this.$refs.modalConfirmation.modalHide()
				this.$refs.modalAlert.modalShow()
			})
		},
		gotoPage(val) {
			this.page = val
			this.getReceipt(this.queryString({page: this.page, limit : this.limit, params:[this.status]}))
		},
		refresh(val) {
			this.page = val
			this.getReceipt(this.queryString({page: this.page, limit : this.limit, params:[this.status]}))
		},
		changeLimit(val) {
			this.page = 1
			this.limit = val
			this.getReceipt(this.queryString({page: this.page, limit : this.limit, params:[this.status]}))
		},
		async getDetail(code) {
			await this.getDetailSO({
				so_code: code
			}).then(() => {
				this.$refs.modalDetailPemesanan.modalShow()
			}).catch( err => {
				this.alert = err
				this.$refs.modalAlert.modalShow()
			})
		},
		nextDis() {
			this.next = 1
		},
		prevDis() {
			this.next = 0
		},
		onDecode(val) {
			if (val) {
				this.params.sdo_code = val
				this.saveReceipt()
			}
		},
		switchCamera () {
			switch (this.camera) {
				case 'front':
				this.camera = 'rear'
				break
				case 'rear':
				this.camera = 'front'
				break
			}
		},
		async onInit (promise) {
			try {
				await promise
			} catch (error) {
				const triedFrontCamera = this.camera === 'front'
				const triedRearCamera = this.camera === 'rear'

				const cameraMissingError = error.name === 'OverconstrainedError'

				if (triedRearCamera && cameraMissingError) {
					this.noRearCamera = true
					this.camera = 'front'
				}

				if (triedFrontCamera && cameraMissingError) {
					this.noFrontCamera = true
					this.camera = 'rear'
				}
			}
		},
		clearData() {
			this.params.sdo_code = ''
		},
		sumTotal(data) {
			let total = 0
			data.forEach( el => {
				total += el.so_detail_quantity_sold *el.so_detail_product_price
			});
			return total
		},
		paymentType() {
			if (this.detailSO.so_payment_type) {
				this.so_payment_type = this.detailSO.so_payment_type.split(',')
			} else {
				this.so_payment_type = []
			}
		},
		cancel_SO(so_id) {
			this.cancel_so_id = so_id
			this.confirmMessage = 'Apakah anda yakin ingin membatalkan pemesanan ini?'
			this.$refs.modalConfirmationCancel.modalShow()
		},
		cancel_SO_refund(so_id) {
			this.cancel_so_id = so_id
			this.refund_error_message = ''
			this.$refs.modalPengajuanPembatalan.modalShow()
		},
		confirmCancel() {
			//console.log('proses cancel SO ' + this.cancel_so_id)

			let params = {
				so_id: this.cancel_so_id
			}
			this.cancelSO(params).then(() => {
				this.$refs.modalConfirmationCancel.modalHide()
				this.getReceipt(this.queryString({page: this.page, limit : this.limit, params:[this.status]}))
				this.getPurchaseOrder()
			}).catch((msg) => {
				this.alert = msg
				this.$refs.modalConfirmationCancel.modalHide()
				this.$refs.modalAlert.modalShow()
			})
		},
		tutupModalRefund() {
			this.$refs.modalPengajuanPembatalan.modalHide()
		},
		confirmCancelRefund() {
			//console.log('proses cancel SO ' + this.cancel_so_id)

			let params = {
				so_id: this.cancel_so_id,
				refund_data_bank_name: this.refund_data_bank_name,
				refund_data_bank_customer_name: this.refund_data_bank_customer_name,
				refund_data_bank_customer_number: this.refund_data_bank_customer_number,
			}
			this.cancelSO(params).then(() => {
				this.$refs.modalPengajuanPembatalan.modalHide()
				this.getReceipt(this.queryString({page: this.page, limit : this.limit, params:[this.status]}))
				this.getPurchaseOrder()
			}).catch((msg) => {
				//this.alert = msg
				//this.$refs.modalPengajuanPembatalan.modalHide()
				//this.$refs.modalAlert.modalShow()

				this.refund_error_message = msg
			})
		},
		getDataFilter(status) {
			this.status.value = status
			this.getReceipt(this.queryString({page: this.page, limit : this.limit, params:[this.status]}))
		},
	},
	computed: {
		...mapState('receipt', ['listReceipt', 'detailSO', 'konfirmResponse', 'responSukses', 'pagination', 'dataPurchaseOrder']),
		...mapState('po', ['dataBank']),
	},
	created () {
		const queryParams = this.$route.query;
		if (queryParams.q) {
			this.status.value = queryParams.q
		}
		this.$store.dispatch('setPageTitle', 'Pemesanan Barang');
		this.getReceipt(this.queryString({page: this.page, limit : this.limit, params:[this.status] }))
		this.getBank()
		this.getPurchaseOrder()
	}
};
</script>